export enum AuthFlowRoute {
    PASSWORD = "PASSWORD",
    SSO = "SSO",
}

export const COMMON_AUTH_CONFIG = {
    identitiesAttributeKey: "identities",
}
